import React from 'react';

import GeneralAssemblyReferent from '../../components/Analyzing/GeneralAssemblyReferent';

function GeneralAssemblyReferentView() {
  return (
    <GeneralAssemblyReferent />
  );
}

export default GeneralAssemblyReferentView;
